/* Olfé bundelkeuze op de gewone productpagina (snippets/olfe-bundel-picker.liquid).
   Per onderdeel: product (T-shirt/Tanktop), kleur en maat, in de opmaak van de variantkiezer van het thema.
   Elke product/kleur-combinatie is een eigen bundelproduct; dit script zet de gekozen bundelvariant in het
   productformulier van het thema, werkt de themaprijs bij (de creatorcode-prijs rekent daarop verder), toont
   in de galerij per onderdeel voor- en achterkant in de gekozen kleur, geeft per onderdeel een fotorij met
   productfoto (tik = alle foto's in een viewer) en geeft de keuze mee als regeleigenschappen voor de winkelwagen. */
(function () {
  'use strict';

  function strip(s) { return String(s == null ? '' : s).replace(/<[^>]*>/g, ''); }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).split('.');
    var s = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    return strip(fmt || '€{{amount_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function views(list) { return (list || []).filter(function (x) { return x && x.id; }); }

  /* ---------- fotoviewer (één voor de hele pagina) ---------- */
  var lb = null;
  function lightbox(t) {
    if (lb) return lb;
    var el = document.createElement('div');
    el.className = 'obp-lb';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML =
      '<div class="obp-lb__bar"><span class="obp-lb__title"></span><span class="obp-lb__count"></span>' +
      '<button type="button" class="obp-lb__close" aria-label="' + esc(t.close) + '"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="obp-lb__track"></div>' +
      '<button type="button" class="obp-lb__nav obp-lb__nav--prev" aria-label="' + esc(t.prev) + '"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="obp-lb__nav obp-lb__nav--next" aria-label="' + esc(t.next) + '"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="obp-lb__dots"></div>';
    document.body.appendChild(el);
    var track = el.querySelector('.obp-lb__track');
    var count = el.querySelector('.obp-lb__count');
    var dots = el.querySelector('.obp-lb__dots');
    var lastFocus = null, n = 0;
    function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function mark() {
      var k = cur();
      count.textContent = n > 1 ? (k + 1) + ' / ' + n : '';
      each(dots.children, function (d, i) { d.classList.toggle('is-on', i === k); });
    }
    function go(k) { track.scrollTo({ left: Math.max(0, Math.min(n - 1, k)) * track.clientWidth, behavior: 'smooth' }); }
    function close() {
      el.hidden = true;
      document.documentElement.classList.remove('obp-lb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame ? requestAnimationFrame(mark) : mark(); }, { passive: true });
    el.querySelector('.obp-lb__close').addEventListener('click', close);
    el.querySelector('.obp-lb__nav--prev').addEventListener('click', function () { go(cur() - 1); });
    el.querySelector('.obp-lb__nav--next').addEventListener('click', function () { go(cur() + 1); });
    el.addEventListener('click', function (e) { if (e.target === el || e.target.classList.contains('obp-lb__slide')) close(); });
    document.addEventListener('keydown', function (e) {
      if (el.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(cur() + 1);
      else if (e.key === 'ArrowLeft') go(cur() - 1);
    });
    lb = {
      open: function (title, list, start) {
        lastFocus = document.activeElement;
        n = list.length;
        el.querySelector('.obp-lb__title').textContent = title;
        track.innerHTML = list.map(function (v, i) {
          return '<div class="obp-lb__slide"><img src="' + esc(v.l) + '" alt="' + esc(title + ' ' + (i + 1)) + '"' + (i === start ? '' : ' loading="lazy"') + '></div>';
        }).join('');
        dots.innerHTML = n > 1 ? list.map(function () { return '<span></span>'; }).join('') : '';
        el.classList.toggle('is-single', n < 2);
        el.hidden = false;
        document.documentElement.classList.add('obp-lb-open');
        track.scrollLeft = start * track.clientWidth;
        mark();
        el.querySelector('.obp-lb__close').focus({ preventScroll: true });
      }
    };
    return lb;
  }

  function init(el) {
    if (el.obpReady) return;
    el.obpReady = true;

    var data = JSON.parse(el.querySelector('[data-obp-data]').textContent);
    var t = data.t, parts = data.parts, combos = data.combos;
    var slots = Array.prototype.slice.call(el.querySelectorAll('[data-obp-part]'));
    var n = slots.length;

    var info = el.closest('product-info');
    var section = el.closest('.shopify-section') || document;
    var form = info ? document.getElementById(info.getAttribute('form')) : null;
    if (!form) return;
    var formId = form.getAttribute('id'); /* form.id is het invoerveld name="id" */
    var idInput = form.querySelector('[name="id"]');
    var priceBox = document.getElementById('Price-' + info.getAttribute('data-section-id') + '-' + info.getAttribute('data-product-id'));
    var priceEl = priceBox ? priceBox.querySelector('.price') : null;
    var gallery = section.querySelector('media-gallery');
    var uid = 'obp' + Math.random().toString(36).slice(2, 7);

    var props = document.createElement('div');
    props.hidden = true;
    props.setAttribute('data-obp-props', '');
    form.appendChild(props);

    /* galerijfoto's die bij een onderdeel+kleur horen; overige foto's (bijv. een sfeerfoto) blijven altijd staan */
    var managed = {};
    Object.keys(parts).forEach(function (pid) {
      var m = parts[pid] && parts[pid].media;
      if (m) Object.keys(m).forEach(function (c) { (m[c] || []).forEach(function (id) { managed[id] = true; }); });
    });

    var mannequin = data.mannequin || {};
    Object.keys(mannequin).forEach(function (k) { if (k !== '_' && mannequin[k]) managed[mannequin[k]] = true; });
    var main = combos.filter(function (c) { return c.main; })[0] || combos[0];
    var st = { prod: main.parts.slice(), col: main.colors.slice(), size: main.parts.map(function () { return null; }) };

    function label(pid) { var p = parts[pid] || {}; return (t.labels && t.labels[p.type]) || p.type || p.title; }
    function slotProducts(i) { return uniq(combos.map(function (c) { return c.parts[i]; })); }
    function slotColors(i) {
      var cs = uniq(combos.filter(function (c) { return c.parts[i] === st.prod[i]; }).map(function (c) { return c.colors[i]; }));
      cs.sort(function (a, b) { return (a === 'Midnight Blauw' ? -1 : 0) - (b === 'Midnight Blauw' ? -1 : 0); });
      return cs;
    }
    function combo() {
      for (var k = 0; k < combos.length; k++) {
        var c = combos[k], ok = true;
        for (var i = 0; i < n; i++) if (c.parts[i] !== st.prod[i] || c.colors[i] !== st.col[i]) { ok = false; break; }
        if (ok) return c;
      }
      return null;
    }
    function sizesFor(c, i) { return c ? uniq(c.variants.map(function (v) { return v.o[i]; })) : []; }
    function sizeOk(c, i, val) {
      return !!c && c.variants.some(function (v) {
        if (!v.a || v.o[i] !== val) return false;
        for (var j = 0; j < n; j++) if (j !== i && st.size[j] !== null && v.o[j] !== st.size[j]) return false;
        return true;
      });
    }
    function complete() { return st.size.every(function (s) { return s !== null; }); }
    function variant(c) {
      if (!c || !complete()) return null;
      for (var k = 0; k < c.variants.length; k++) {
        var v = c.variants[k], ok = true;
        for (var i = 0; i < n; i++) if (v.o[i] !== st.size[i]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function submitButtons() { return document.querySelectorAll('[type="submit"][form="' + formId + '"], #' + formId + ' [type="submit"]'); }

    /* radio + label in dezelfde opmaak als de variantkiezer van het thema */
    function radio(kind, i, k, value, checked, disabled, labelHtml, labelCls, style, title) {
      var id = uid + '-' + i + '-' + kind + '-' + k;
      return '<li><input type="radio" class="sr-only" id="' + id + '" name="' + uid + '-' + i + '-' + kind + '" value="' + esc(value) + '" data-obp-' + kind + '="' + esc(value) + '"' +
        (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
        '<label for="' + id + '" class="' + labelCls + '"' + (style ? ' style="' + style + '"' : '') + (title ? ' title="' + esc(title) + '"' : '') + '>' + labelHtml + '</label></li>';
    }

    /* ---------- themaprijs, sticky balk en knop ---------- */
    function priceEls() {
      var out = [];
      if (priceEl) out.push(priceEl);
      var sticky = document.getElementById('StickyPrice-' + info.getAttribute('data-section-id') + '-' + info.getAttribute('data-product-id'));
      if (sticky) each(sticky.querySelectorAll('.price'), function (p) { out.push(p); });
      return out;
    }
    function syncPrice(ref) {
      if (!ref) return;
      priceEls().forEach(function (pe) {
        /* Codeprijs via de creatorcode-module; data-cc-bundle = alleen een echte proefwagen telt (VIP15 wel, andere codes niet). */
        if (pe.getAttribute('data-cc-variant') === String(ref.id)) return;
        pe.setAttribute('data-cc-variant', ref.id);
        pe.setAttribute('data-cc-price', ref.p);
        pe.setAttribute('data-cc-compare', ref.c || 0);
        pe.setAttribute('data-cc-bundle', 'true');
        var reg = pe.querySelector('.price__regular');
        if (reg) reg.textContent = money(ref.p, data.money);
        var sale = pe.querySelector('.price__sale');
        if (sale) sale.textContent = money(ref.c, data.money);
        pe.classList.toggle('price--on-sale', ref.c > ref.p);
      });
      each(document.querySelectorAll('[data-sticky-product-options]'), function (o) {
        var txt = slots.map(function (s, i) { return (t.colors[st.col[i]] || st.col[i]) + (st.size[i] ? ' ' + st.size[i] : ''); }).join(' · ');
        if (o.textContent !== txt) o.textContent = txt;
      });
      each(document.querySelectorAll('product-buy-price[form="' + formId + '"]'), function (bp) {
        if (bp.getAttribute('data-price') === String(ref.p)) return;
        bp.setAttribute('data-price', ref.p);
        bp.removeAttribute('data-cc-buy');
        bp.classList.remove('cc-buy-active');
        bp.textContent = money(ref.p, data.money);
      });
    }
    function syncButton(v) {
      var lbl = !complete() ? t.choose : (!v || !v.a) ? t.soldout : t.add;
      each(submitButtons(), function (b) {
        var isSticky = !!b.closest('product-sticky-form');
        var span = b.querySelector('.btn-text > span:first-child') || b.querySelector('.btn-text') || b;
        if (!b.hasAttribute('data-obp-label')) b.setAttribute('data-obp-label', span.textContent.trim());
        var want = isSticky ? (!complete() ? (t.chooseShort || b.getAttribute('data-obp-label')) : (!v || !v.a) ? t.soldout : b.getAttribute('data-obp-label')) : lbl;
        if (span.textContent !== want) span.textContent = want;
        if (complete() && (!v || !v.a)) b.setAttribute('disabled', ''); else b.removeAttribute('disabled');
        b.classList.toggle('obp-incomplete', !complete());
      });
    }
    function syncProps(v) {
      if (idInput && v) idInput.value = v.id;
      props.innerHTML = '';
      if (!v) return;
      slots.forEach(function (s, i) {
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + label(st.prod[i]) + ']';
        inp.value = (t.colors[st.col[i]] || st.col[i]) + ', ' + st.size[i];
        props.appendChild(inp);
      });
    }

    /* ---------- galerij: per onderdeel voor- en achterkant in de gekozen kleur ---------- */
    function slotOrder() {
      var order = [], legIdx = -1;
      st.prod.forEach(function (pid, i) { if (legIdx < 0 && parts[pid] && parts[pid].type === 'Legging') legIdx = i; });
      st.prod.forEach(function (pid, i) { if (i !== legIdx) order.push(i); });
      if (legIdx >= 0) order.splice(Math.min(1, order.length), 0, legIdx);
      return order;
    }
    function syncMedia() {
      if (!gallery) return;
      var order = slotOrder(), ids = [];
      /* eerst de mannequinfoto van deze combinatie (T-shirt- of tanktopversie, anders die van de hele bundel) */
      var mq = null;
      st.prod.forEach(function (pid) { var ty = parts[pid] && parts[pid].type; if (!mq && ty && mannequin[ty]) mq = mannequin[ty]; });
      mq = mq || mannequin.all;
      if (mq) ids.push(String(mq));
      [0, 1].forEach(function (pos) {            /* eerst alle voorkanten, dan alle achterkanten */
        order.forEach(function (i) {
          var p = parts[st.prod[i]], list = p && p.media && p.media[st.col[i]];
          if (list && list[pos]) ids.push(String(list[pos]));
        });
      });
      var want = {}; ids.forEach(function (id) { want[id] = true; });
      var changed = false;
      each(gallery.querySelectorAll('[data-media-id]'), function (node) {
        var id = node.getAttribute('data-media-id');
        if (!managed[id]) return;
        var hide = !want[id];
        if (node.hidden !== hide) { node.hidden = hide; changed = true; }
      });
      ['.product__media', '.product__thumbnail'].forEach(function (cls) {
        var nodes = ids.map(function (id) { return gallery.querySelector(cls + '[data-media-id="' + id + '"]'); }).filter(Boolean);
        if (!nodes.length) return;
        var parent = nodes[0].parentNode;
        var cur = Array.prototype.filter.call(parent.children, function (x) { return x.matches(cls) && !x.hidden; });
        if (nodes.every(function (nd, k) { return cur[k] === nd; })) return;
        for (var k = nodes.length - 1; k >= 0; k--) parent.insertBefore(nodes[k], parent.firstChild);
        changed = true;
      });
      if (changed) {
        window.dispatchEvent(new Event('resize'));
        var slider = gallery.querySelector('slider-element');
        if (slider && slider.scrollLeft) slider.scrollTo({ left: 0, behavior: 'auto' });
      }
    }

    function render() {
      var c = combo();
      slots.forEach(function (slot, i) {
        var pid = st.prod[i], p = parts[pid] || {};
        var a = slot.querySelector('[data-obp-ptitle]');
        a.textContent = p.title; a.href = p.url;
        slot.querySelector('[data-obp-chart]').setAttribute('aria-controls', p.chart);

        /* productfoto naast de naam: voorkant in de gekozen kleur; tikken opent alle foto's */
        var vs = views(p.views && p.views[st.col[i]]);
        var img = slot.querySelector('[data-obp-thumbimg]');
        var thumb = slot.querySelector('[data-obp-thumb]');
        thumb.hidden = !vs.length;
        if (vs.length && img.getAttribute('src') !== vs[0].s) { img.setAttribute('src', vs[0].s); img.removeAttribute('loading'); }
        thumb.setAttribute('aria-label', t.views + ' ' + p.title);

        /* top-keuze (T-shirt / Tanktop) */
        var prods = slotProducts(i);
        var pw = slot.querySelector('[data-obp-products-wrap]');
        pw.hidden = prods.length < 2;
        if (prods.length > 1) {
          slot.querySelector('[data-obp-products]').innerHTML = prods.map(function (q, k) {
            return radio('prod', i, k, q, q === pid, false, esc(label(q)), 'obp__segbtn', '', label(q));
          }).join('');
        }

        /* kleuren */
        slot.querySelector('[data-obp-cname]').textContent = t.colors[st.col[i]] || st.col[i];
        /* "kleur kan iets afwijken": alleen bij een Midnight T-shirt / tanktop (andere stof dan legging en beha) */
        var cn = slot.querySelector('[data-obp-cnote]');
        if (cn) cn.hidden = !((p.type === 'T-shirt' || p.type === 'Tanktop') && st.col[i] === 'Midnight Blauw');
        slot.querySelector('[data-obp-colors]').innerHTML = slotColors(i).map(function (col, k) {
          var name = t.colors[col] || col;
          var hex = (p.hex && p.hex[col]) || (col === 'Zwart' ? '#000000' : '#01357A');
          return radio('col', i, k, col, col === st.col[i], false,
            '<span class="sr-only">' + esc(name) + '</span><span class="tooltip opacity-0 pointer-events-none text-xs rounded-full z-10">' + esc(name) + '</span>',
            'color-swatch cursor-pointer block relative', '--swatch-background: ' + hex + ';', name);
        }).join('');

        /* maten */
        slot.querySelector('[data-obp-sizes]').innerHTML = sizesFor(c, i).map(function (val, k) {
          return radio('size', i, k, val, st.size[i] === val, !sizeOk(c, i, val), esc(val), 'label-swatch text-sm font-medium leading-none cursor-pointer block relative', '', val);
        }).join('');
      });

      var v = variant(c);
      var ref = v || (c && (c.variants.filter(function (x) { return x.a; })[0] || c.variants[0]));
      syncPrice(ref);
      syncProps(v && v.a ? v : null);
      if (idInput && !v && ref) idInput.value = ref.id;
      syncButton(v);
      syncMedia();
    }

    function nudge() {
      var first = null;
      slots.forEach(function (s, i) { var miss = st.size[i] === null; s.classList.toggle('is-missing', miss); if (miss && !first) first = s; });
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* Zonder volledige maatkeuze niet toevoegen: vóór de thema-handler afvangen. */
    function guard(e) {
      var target = e.type === 'submit' ? e.target : (e.target.closest && e.target.closest('[type="submit"]'));
      if (!target) return;
      var f = e.type === 'submit' ? target : (target.form || document.getElementById(target.getAttribute('form')));
      if (f !== form) return;
      var v = variant(combo());
      if (v && v.a) { syncProps(v); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      nudge();
    }
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);

    /* keuzes: change-events van onze radio's (niet doorgeven aan de thema-scripts) */
    el.addEventListener('change', function (e) {
      var inp = e.target;
      var slot = inp.closest('[data-obp-part]'), i = slot ? slots.indexOf(slot) : -1;
      if (i < 0) return;
      e.stopPropagation();
      if (inp.hasAttribute('data-obp-prod')) {
        st.prod[i] = inp.value;
        var cols = slotColors(i); if (cols.indexOf(st.col[i]) < 0) st.col[i] = cols[0];
        st.size[i] = null;
      } else if (inp.hasAttribute('data-obp-col')) {
        st.col[i] = inp.value;
        if (st.size[i] !== null && !sizeOk(combo(), i, st.size[i])) st.size[i] = null;
      } else if (inp.hasAttribute('data-obp-size')) {
        st.size[i] = inp.value;
        slot.classList.remove('is-missing');
      } else return;
      render();
      var again = slot.querySelector('input[name="' + inp.name + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(inp.value) : inp.value) + '"]');
      if (again) again.focus({ preventScroll: true });
    });

    /* fotorij → grote fotoviewer */
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-obp-thumb]');
      if (!b) return;
      var slot = b.closest('[data-obp-part]'), i = slots.indexOf(slot);
      var p = parts[st.prod[i]] || {};
      lightbox(t).open(p.title + ' · ' + (t.colors[st.col[i]] || st.col[i]), views(p.views && p.views[st.col[i]]), 0);
    });

    /* Het thema tekent knop/prijs soms opnieuw (bijv. na toevoegen): daarna onze stand terugzetten. */
    var again = null;
    new MutationObserver(function () { clearTimeout(again); again = setTimeout(function () { syncButton(variant(combo())); }, 80); })
      .observe(form.closest('product-info') || form, { childList: true, subtree: true });

    render();
  }

  function boot() { each(document.querySelectorAll('[data-obp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
